import { setUserProperties } from '@atlassian/jira-common-rest/src/api/latest/user-properties/index.tsx';
import FetchError from '@atlassian/jira-fetch/src/utils/errors.tsx';
import { fireErrorAnalytics } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';
import { getTenantContext_DEPRECATED_DO_NOT_USE } from '@jira/platform__get-tenant-context/src/index.tsx';

type AccountId = string;

type Data = {
	key: string;
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	value: string | boolean | Record<any, any>; // TODO: Fix type
};

const getAccountId = (): AccountId => {
	const { atlassianAccountId } = getTenantContext_DEPRECATED_DO_NOT_USE();
	if (atlassianAccountId === null) {
		throw new Error('Atlassian Account Id is empty');
	}
	return atlassianAccountId;
};

const setRemoteUserProperties = async ({ key, value }: Data): Promise<void> =>
	setUserProperties(getAccountId(), key, JSON.stringify(value)).then((response) => {
		if (!response.ok) {
			throw new FetchError(response.status, response.statusText);
		}
	});

const trySetUserProperties = async (props: Data, attemptCount: number) => {
	try {
		await setRemoteUserProperties(props);
		// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		fireErrorAnalytics({
			meta: {
				id: 'pushToBackend',
				packageName: 'jiraOnboardingQuickstartCore',
				teamName: 'jlove-makkuro',
			},
			attributes: {
				action: 'pushToBackend',
				actionSubject: 'jiraOnboardingChecklistCore',
				attemptCount,
				key: props.key,
				reason: error && error.message,
			},
			error,
		});
		return false;
	}

	return true;
};

export const pushToBackend = async (props: Data): Promise<void> => {
	const success = await trySetUserProperties(props, 1);

	if (!success) {
		// On failure retry - if retry fails data is lost.
		await trySetUserProperties(props, 2);
	}
};
